const clearPageTemplatesHtml = (pageTemplates) =>
  pageTemplates.map((pageTemplate) => ({
    ...pageTemplate,
    html: '',
  }));

export default clearPageTemplatesHtml;
